import axios from "axios"
const baseUrl = process.env.VUE_APP_BASE_URL
const associations = 
{
    namespaced: true,
    state: {
        associations: [],
        association: {}
    },
    mutations: {
        SET_ASSOCIATIONS(state, data)
        {
            state.associations = data
        },
        SET_ASSOCIATION(state, data)
        {
            state.association = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios
          .get(baseUrl+'/associations/', { withCredentials: true })
          .then(res => {
                commit('SET_ASSOCIATIONS', res.data)
                console.log("service APi",res.data)
          })
          .catch(error => console.log(error))
        },

        deleteAssociation ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteHomeOwner?homeOwnerId=' + id, { withCredentials: true })
            
            .catch(error => console.log(error))
          },
          updateAssociation({ commit }, association){
            return axios
            .post(baseUrl+'AddUpdateHomeOwner', association, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getAssociation ({ commit },id) {
            return axios
            .get(baseUrl+'GetHomeOwner?homeOwnerId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_ASSOCIATION', res.data)
            })
            .catch(error => console.log(error))
        },
        addAssociation ({ commit }, association) {
           return axios
            .post(baseUrl+'associations/association', association, { withCredentials: true })
            .then(res => {
               commit('SET_ASSOCIATIONS', res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default associations